import Footer from '@/components/feature/Footer'

export default function HomeFooterSection() {
  return (
    <section className="home-footer-section" aria-label="平台页尾导航">
      <Footer />
    </section>
  )
}
